export const SUMMARY_TAG_NAME = 'p';
